<template>
    <div class="filter-popup" v-bind:style="{display: toggled ? 'inline-block' : 'none'}" v-if="toggled">
        <div class="background" v-on:click="Close()"></div>
        
        <div style="border-bottom:1px solid #e5e5e5;">
            <div style="color: #6d8d23; font-size: 24px; font-family: DistrictProBook; font-weight: 900; padding-bottom: 7px;">
                Filter
            </div>
        </div>








        <div style="border-top:1px solid #e5e5e5; border-bottom:1px solid #e5e5e5; padding-top:10px; padding-bottom: 10px;">
            <div class="buWhite" v-on:click="ToggleBusinessUnits()">
                    <div style="display:inline-block; padding-left: 10px; cursor:pointer;">{{ $t('roster.comp.groupByUnit') }}</div>
                    <div v-if="rosterSortState.showBusinessUnits" style="float:right; width: 20px; color:#6d8d23;"><i class="fas fa-check-circle"></i></div>
                    <div v-else style="float:right; width: 20px; color:#ccc;"><i class="fas fa-circle"></i></div>
            </div>
            
        </div>
    </div>
</template>


<script>
    import { mapState, mapGetters } from 'vuex';
    export default {
        name: 'filterpopuppreferences',
        components: {
        },
        data(){
            return{
                toggled: false,
                rawData: null,
                softSkillsFiltered: [],
                toggleAll: false,
                groups: [],
                spots: [],
            }
        },
        created () {
            var view = this;
        },
        destroyed(){
        },
        computed: {
            ...mapGetters([
                'rosterSortState'
            ]),
           
        },
        methods: {
            Close(){
                //if($(window.mouse.element).closest('.filter-popup').length > 0) return;
                this.Toggle(false);
            },
            Toggle(val){
                if(val !== undefined || val !== null) {
                    this.toggled = val;
                    return;
                }
                this.toggled = !this.toggled;
            },
            Init(){
                
                this.toggled = true;

                console.log(this.$parent.employeeGroups);

                this.groups = this.$parent.employeeGroups;
            },
            InitData(){
                var view = this;
            },
            ToggleBusinessUnits(){
                this.rosterSortState.filterByShiftSpot = false;
                this.rosterSortState.showSpots = false;
                this.rosterSortState.showShiftSpots = false;
                this.rosterSortState.showSpotPlanningNumbersSwitch = false;
                this.rosterSortState.showBusinessUnits = !this.rosterSortState.showBusinessUnits;
                this.$store.commit('setRosterSortState', {rosterSortState: this.rosterSortState});

                this.$parent.$forceUpdate();
            },
            ToggleDynamicFilter(){
                this.$parent.dynamicFiltering = !this.$parent.dynamicFiltering;
                this.$parent.filterEmployees();
            },
            ToggleSkill($event, skillId, id, idmap){
                if(id != null) this.$parent.softSkills[id].toggled = !this.$parent.softSkills[id].toggled;
                if(idmap != null) this.$parent.spotMap[idmap].toggled = !this.$parent.spotMap[idmap].toggled;

                let index = this.$parent.softSkillsFiltered.indexOf(skillId);
                if (index !== -1){
                    this.$parent.softSkillsFiltered.splice(index, 1);
                }else{
                    this.$parent.softSkillsFiltered.push(skillId);
                }
                this.$parent.filterEmployees();
                this.$forceUpdate();
            },
            toggleObj(obj){
                (obj.showMajor) ? obj.showMajor = false : obj.showMajor = true;

                if(!obj.showMajor && obj.spot != null){
                    for(let i in this.groups){
                        let o = this.groups[i];
                        if(o.spot != null && o.spot.parentId == obj.spot.id){
                            o.showMajor = false;
                        }
                    }
                }
                this.$forceUpdate();
            },
            toggleAllGroups(){
                this.toggleAll = !this.toggleAll;
                this.groups.forEach(group => group.showMajor = this.toggleAll);
            }

        },
        mounted() {
            $('html').append(this.$el);
        }
    }
</script>


<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

    .dynFilterGray{
        background-color: #e5e5e5; 
        padding:7px 10px; 
        border-radius: 5px;
        border:solid 1px #777;

        color: #111; 
        cursor:pointer; 

        transition: background-color 500ms linear;
        transition: color 500ms linear;
    }
    .dynFilterGreen{
        background-color: #6d8d23; 
        padding:7px 10px; 
        border-radius: 5px;
        border:solid 1px #777;

        color: #fff; 
        cursor:pointer; 

        transition: background-color 500ms linear;
        transition: color 500ms linear;
    }



    .buBackgroudGreen{
        background-color: #6d8d23; 
        padding:5px 10px; 
        border-radius: 20px; 
        color: #fff; 
        cursor:pointer; 
        transition: background-color 500ms linear;
        transition: color 500ms linear;
        font-weight: 800;
    }
    .buBackgroudGray{
        background-color: #ccc; 
        padding:5px 10px; 
        border-radius: 20px; 
        color: #fff; 
        cursor:pointer; 
        transition: background-color 500ms linear;
        transition: color 500ms linear;
        font-weight: 800;
    }
    
    .spotBackgroudGreen{
        margin-left: 35px;
        background-color: #6d8d23; 
        padding:5px 10px; 
        border-radius: 20px; 
        color: #fff; 
        cursor:pointer; 
        transition: background-color 1000ms linear;
        transition: color 1000ms linear;
    }
    .spotBackgroudGray{
        margin-left: 35px;
        background-color: #ccc; 
        padding:5px 10px; 
        border-radius: 20px; 
        color: #fff; 
        cursor:pointer; 
        transition: background-color 1000ms linear;
        transition: color 1000ms linear;
        font-weight: 800;
    }



    .buWhite{
        background-color: #fff; 
        padding:4px 0px; 
        border-radius: 20px; 
        color: #333; 
        cursor:pointer;
    }

    .filter-popup{
        position:fixed;
        display:inline-block;
        max-height: 520px;
        width: 450px;
        border-radius: 5px;
        display:none;
        z-index: 1000;
        background: white;
        box-shadow: 4px 4px 5px 3px rgba(0,0,0,0.2);
        border: 1px solid #a5a5a5;
        padding: 40px;

        top: 120px;
        left: 78px;
        overflow-y: auto;
    }

     .background {
        position: fixed;
        height: 100vh;
        width: 100vw;
        left: 0;
        right: 0;
        z-index: -1;
        top: 0;
    }


    .header{
        margin-bottom:45px;
    }
    .header .label{
        box-shadow: inset 0 -1px 0 0px #ebebeb;
        font-size: 20px;
    }

    .fa-stack.cancel{
        cursor: pointer;
        position: absolute;
        top: 6px;
        right: 5px;
        font-size: 10px;
        transform: scale(.8);
    }
    .fa-stack.cancel .fa-circle{
    }
    .fa-stack.cancel .fa-times{
        font-size: 13px;
        transform: translateY(3px);
    }

</style>
